import { OrderFiltersParams } from '@ml/orders/types/interfaces';
import { QueryParams } from '@ml/shared/types/query-params';

export class OrdersFilters {
  status: string[];
  ordering: 'asc' | 'desc' | '';

  constructor(status?: string[]) {
    this.status = status;
  }

  get queryParams(): QueryParams {
    const params = new QueryParams();

    if (this.status) {
      params.status = this.status.join(',');
    }
    if (this.ordering) {
      params.ordering = this.ordering;
    }

    return params;
  }

  static fromParams(params: OrderFiltersParams): OrdersFilters {
    const ordersFilter = new OrdersFilters();
    if (params.status) {
      ordersFilter.status =
        typeof params.status === 'string' ? [params.status] : params.status;
    }
    if (params.ordering) {
      ordersFilter.ordering = params.ordering;
    }

    return ordersFilter;
  }

  get params(): OrderFiltersParams {
    const params: OrderFiltersParams = {};
    if (this.status) {
      params.status = this.status;
    }
    if (this.ordering) {
      params.ordering = this.ordering;
    }
    return params;
  }

  get empty() {
    return !(this.status && this.status.length > 0);
  }
}
